import React from 'react';
import PropTypes from 'prop-types';
import "./Quote.css";
import { getCurrentRevisionIndex } from '../../store/quotesAndNotificationsSlice';
import { quoteStatusClass } from '../../store/quotesAndNotificationsSlice';

function Quote(props){

    const standardListItems = [];
    const miscellaneousListItems = [];
    const machineItems = [];

    const productFlags = [];
    const machineFlags = [];
    let estimatedTotalValueFlagNum = -1;
    let previousRevision, etvChanged, expDateChanged;

    const showHistory = (props.view === 'quotes' && props.sidePanelTitle.toLowerCase() === 'history') ? true : false;

    //let currentRevision = props.quote.quote[ getCurrentRevisionIndex(props.quote) ];
    let currentRevision = props.quote.quote[ 0 ];

    const activeQuoteInfo = props.activeQuoteInfo;

    const isCurrentQUoteComparison = (showHistory && activeQuoteInfo.quoteId === props.quote.quoteId && activeQuoteInfo.revisionNumber !== currentRevision.revisionNumber );

    if ( isCurrentQUoteComparison ){ //revision history and this quote is current quote
        const compareRevisions = getComparisonRevisions(props.quote.quote, props.activeQuoteInfo);
        currentRevision = compareRevisions.currentRevision;
        previousRevision = compareRevisions.previousRevision;
    } 

    const {
        generalInformation,
        productInformation,
        machinesAndTools,
        flags
    } = currentRevision;

    const {
        customer 
    } = generalInformation.customerInformation;

    const {
        activationDate,
        expirationDate
    } = generalInformation.activationDuration;

    const {
        estimatedTotalValue,
        quoteSubject,
        opportunityNumber,
        market,
        asm
    } = generalInformation.generalDetails;

    if ( isCurrentQUoteComparison ){

        const comparisonInfo = diffRevisions(previousRevision, currentRevision);
        const {
            standardItems,
            miscellaneousItems,
            machinesAndTools
        } = comparisonInfo;

        etvChanged = comparisonInfo.estimatedTotalValue;
        expDateChanged = comparisonInfo.expirationDate;

        let standardLiClassName;
        standardItems.forEach((item, i) => {
            if ( item.change === 'none' ){
                standardLiClassName = "quote_standard_items_li";
            } else if ( item.change === 'old' ){
                standardLiClassName = "quote_standard_items_li old_change_red";
            } else {
                standardLiClassName = "quote_standard_items_li new_change_green";
            }
            if ( item.productDescription !== '' ){
                let flagObj = productFlags.find( flag => flag.value === item.productDescription );
                standardListItems.push(
                    <li key={item.productDescription + i} className={ standardLiClassName }>
                        <div className="quote_standard_product_description_container">
                            <p className="quote_list_item" title={ item.productDescription }>{ item.productDescription }</p>
                        </div>
                        <div className="quote_discount_container">
                            <p className="quote_list_item" title={ item.discount }>{ item.discount }</p>
                        </div>
                        <div className="quote_percentage_container">
                            <p className="quote_list_item" title={ item.percentage.toString().replace(/%/g, '') + '%' }>{ item.percentage.toString().replace(/%/g, '') + '%' }</p>
                        </div>
                        <div className="quote_multiplier_container">
                            <p className="quote_list_item" title={ item.multiplier }>{ item.multiplier }</p>
                        </div>
                        {
                            flagObj !== undefined &&
                            <span className="flag_number">{ flagObj.flagNum }</span>
                        }
                    </li>
                );
            }
        });
        let miscellaneousLiClassname;
        miscellaneousItems.forEach((item, i) => {
            if ( item.change === 'none' ){
                miscellaneousLiClassname = "quote_miscellaneous_items_li";
            } else if ( item.change === 'old' ){
                miscellaneousLiClassname = "quote_miscellaneous_items_li old_change_red";
            } else {
                miscellaneousLiClassname = "quote_miscellaneous_items_li new_change_green";
            }
            if ( item.productDescription !== '' ){
                miscellaneousListItems.push(
                    <li key={item.productDescription + i} className={ miscellaneousLiClassname }>
                        <div className="quote_misc_product_description_container">
                            <p className="quote_list_item" title={ item.productDescription }>{ item.productDescription }</p>
                        </div>
                        <div className="quote_total_percent_off_container">
                            <p className="quote_list_item" title={ item.totalPercentOff }>{ item.totalPercentOff.toString().replace(/%/g, '') }{item.totalPercentOff !== '' && '%'}</p>
                        </div>
                        <div className="quote_net_pricing_container">
                            <p className="quote_list_item" title={ item.netPricing }>{ item.netPricing }</p>
                        </div>
                    </li>
                );
            }
        });
        let machineLiClassName;
        machinesAndTools.forEach((item, i) => {
            if ( item.machineDescription !== '' ){
                if ( item.change === 'none' ){
                    machineLiClassName = "machine_items_li";
                } else if ( item.change === 'old' ){
                    machineLiClassName = "machine_items_li old_change_red";
                } else {
                    machineLiClassName = "machine_items_li new_change_green";
                }
                machineItems.push(
                    <li key={item.machineDescription + i} className={ machineLiClassName }>
                        <div className="quote_machine_type_container">
                            <p className="quote_list_item" title={ item.machineDescription }>{ item.machineDescription }</p>
                        </div>
                        <div className="quote_rental_duration_container">
                            <p className="quote_list_item" title={ item.rentalDuration }>{ item.rentalDuration }</p>
                        </div>
                    </li>
                );
            }
        });

    } else {

        const {
            standardItems,
            miscellaneousItems
        } = productInformation;
        
        if( currentRevision && currentRevision.status && currentRevision.status.toLowerCase() === 'pending' ){ //only show flags on pending quotes

            const filteredFlags = flags.filter( flag => flag.status.toLowerCase() === 'pending' );
            //console.log(filteredFlags);
            filteredFlags.forEach( (flag, i) => {
                if( flag.status.toLowerCase() === 'pending' ){
                    switch( flag.types.category.toLowerCase() ){
                        case 'estimated total value':
                            estimatedTotalValueFlagNum = i + 1;
                        break;
                        case 'discount':
                            productFlags.push( { flagNum: i + 1, value: flag.types.meta.productDescription } );
                        break;
                        case 'machine rental duration':
                            machineFlags.push( { flagNum: i + 1, value: flag.types.meta.productDescription } );
                        break;
                        case 'add machine':
                            machineFlags.push( { flagNum: i + 1, value: flag.types.meta.productDescription } );
                        break;
                        //no default
                    }
                }
            });
        }

        standardItems.forEach((item, i) => {
            if ( item.productDescription !== '' ){
                let flagObj = productFlags.find( flag => flag.value === item.productDescription );
                let percentage = item.percentage.toString().replace(/%/g, '');
                percentage = percentage !== '' ? percentage + '%' : percentage;
                standardListItems.push(
                    <li key={item.productDescription + i} className={ flagObj === undefined ? "quote_standard_items_li" : "quote_standard_items_li flag_highlight" }>
                        <div className="quote_standard_product_description_container">
                            <p className="quote_list_item" title={ item.productDescription }>{ item.productDescription }</p>
                        </div>
                        <div className="quote_discount_container">
                            <p className="quote_list_item" title={ item.discount }>{ item.discount }</p>
                        </div>
                        <div className="quote_percentage_container">
                            <p className="quote_list_item" title={ percentage }>{ percentage }</p>
                        </div>
                        <div className="quote_multiplier_container">
                            <p className="quote_list_item" title={ item.multiplier }>{ item.multiplier }</p>
                        </div>
                        {
                            flagObj !== undefined &&
                            <span className="flag_number">{ flagObj.flagNum }</span>
                        }
                    </li>
                );
            }
        });

        miscellaneousItems.forEach((item, i) => {
            if ( item.productDescription !== '' ){
                miscellaneousListItems.push(
                    <li key={item.productDescription + i} className="quote_miscellaneous_items_li">
                        <div className="quote_misc_product_description_container">
                            <p className="quote_list_item" title={ item.productDescription }>{ item.productDescription }</p>
                        </div>
                        <div className="quote_total_percent_off_container">
                            <p className="quote_list_item" title={ item.totalPercentOff }>{ item.totalPercentOff.toString().replace(/%/g, '') }{item.totalPercentOff !== '' && '%'}</p>
                        </div>
                        <div className="quote_net_pricing_container">
                            <p className="quote_list_item" title={ item.netPricing }>{ item.netPricing }</p>
                        </div>
                    </li>
                );
            }
        });

        machinesAndTools.forEach((item, i) => {
            if ( item.machineDescription !== '' ){
                let flagObj = machineFlags.find( flag => flag.value === item.machineDescription );
                machineItems.push(
                    <li key={item.machineDescription + i} className={flagObj === undefined ? "machine_items_li" : "machine_items_li flag_highlight" }>
                        <div className="quote_machine_type_container">
                            <p className="quote_list_item" title={ item.machineDescription }>{ item.machineDescription }</p>
                        </div>
                        <div className="quote_rental_duration_container">
                            <p className="quote_list_item" title={ item.rentalDuration }>{ item.rentalDuration }</p>
                        </div>
                        {
                            flagObj !== undefined &&
                            <span className="flag_number">{ flagObj.flagNum }</span>
                        }
                    </li>
                );
            }
        });
    }

    const customerDiv = <div className="quote_flex_one">
                            <label className="quote_item_label">
                                Customer:
                            </label>
                            <p className="quote_item">
                                { customer }
                            </p>
                        </div>;

    const statusDiv = <div className="quote_status_container quote_flex_two">
                        <label className="quote_item_label">
                            Status:
                        </label>
                        <p className={ "quote_item " + quoteStatusClass(currentRevision.status) }>
                            { currentRevision.status }
                        </p>
                    </div>;

    const oppNumDiv = <div className="quote_opportunityNumber_container quote_flex_two">
                        <label className="quote_item_label">
                            Opportunity #:
                        </label>
                        <p className="quote_item">
                            { opportunityNumber }
                        </p>
                    </div>;

    return (
        <div className="quote_wrapper">
            {
                props.view === "create_quote" &&
                <div className="quote_flex_container">
                    {customerDiv}
                    {oppNumDiv}
                </div>
            }
            {
                props.view === "notifications" &&
                <div className="quote_flex_container quote_flex_top">
                    { customerDiv }
                    { statusDiv }
                </div>
            }
            <div className="quote_flex_container">

                <div className="quote_flex_one">
                    {
                        etvChanged &&
                        <div className="old_change_red">
                            <label className="quote_item_label">
                                Estimated Total Value:
                            </label>
                            <p className="quote_item">
                                ${ previousRevision.generalInformation.generalDetails.estimatedTotalValue.replace(/\$/g, '') }
                            </p>
                        </div>
                    }
                    <div className={ estimatedTotalValueFlagNum !== -1 ? "flag_highlight" : etvChanged ? "new_change_green" : "" }>
                        <label className="quote_item_label">
                            Estimated Total Value:
                        </label>
                        <p className="quote_item">
                            ${ estimatedTotalValue.replace(/\$/g, '') }
                        </p>
                        {
                            estimatedTotalValueFlagNum !== -1 &&
                            <span className="flag_number">{ estimatedTotalValueFlagNum }</span>
                        }
                    </div>
                </div>
                {
                    props.view === "create_quote" &&
                    <div className="quote_flex_two">
                        <label className="quote_item_label">
                            Subject:
                        </label>
                        <p className="quote_item">
                            { quoteSubject }
                        </p>
                    </div>
                }
                {
                    props.view !== "create_quote" &&
                    <div className="quote_flex_two">
                        <label className="quote_item_label">
                            Market:
                        </label>
                        <p className="quote_item">
                            { market }
                        </p>
                    </div>
                }
            </div>
            <div className="quote_flex_container">
                <div className="quote_flex_one">
                    <label className="quote_item_label">
                        Activation Date:
                    </label>
                    <p className="quote_item">
                        { activationDate }
                    </p>
                </div>
                <div className="quote_flex_two">
                    {
                        expDateChanged && 
                        <div className="old_change_red">
                            <label className="quote_item_label">
                                Expiration Date:
                            </label>
                            <p className="quote_item">
                                { previousRevision.generalInformation.activationDuration.expirationDate }
                            </p>
                        </div>
                    }
                    <div className={ expDateChanged ? "new_change_green" : "" }>
                        <label className="quote_item_label">
                            Expiration Date:
                        </label>
                        <p className="quote_item">
                            { expirationDate }
                        </p>
                    </div>
                </div>
            </div>
            <div className="standard_items_container">
                { (standardListItems[0] !== undefined) &&
                    <ul className="quote_list standard_items_list">
                        <li className="quote_list_headers_li">
                            <div className="quote_standard_product_description_container">
                                <p className="quote_list_header">Product Description</p>
                            </div>
                            <div className="quote_discount_container">
                                <p className="quote_list_header">Discount</p>
                            </div>
                            <div className="quote_percentage_container">
                                <p className="quote_list_header">Percentage</p>
                            </div>
                            <div className="quote_multiplier_container">
                                <p className="quote_list_header">Multiplier</p>
                            </div>
                        </li>
                        { standardListItems }
                    </ul>
                }
            </div>
            <div className="miscellaneous_items_container">
                { (miscellaneousListItems[0] !== undefined) &&
                    <ul className="quote_list miscellaneous_items_list">
                        <li className="quote_list_headers_li">
                            <div className="quote_misc_product_description_container">
                                <p className="quote_list_header">Product Description</p>
                            </div>
                            <div className="quote_total_percent_off_container">
                                <p className="quote_list_header">Total % Off</p>
                            </div>
                            <div className="quote_net_pricing_container">
                                <p className="quote_list_header">Net Pricing</p>
                            </div>
                        </li>
                        { miscellaneousListItems }
                    </ul>
                }
            </div>
            <div className="machine_rentals_container">
                { (machineItems[0] !== undefined) &&
                    <ul className="quote_list machine_items_list">
                        <li className="quote_list_headers_li">
                            <div className="quote_machine_type_container">
                                <p className="quote_list_header">Machine Type</p>
                            </div>
                            <div className="quote_rental_duration_container">
                                <p className="quote_list_header">Rental Duration</p>
                            </div>
                        </li>
                        { machineItems }
                    </ul>
                }
            </div>
            {
                currentRevision.additionalNotes && currentRevision.additionalNotes.trim() !== '' &&
                <div className="additional_notes_container">
                    <label className="quote_item_label">Additional Notes:</label>
                    <p className="quote_item_additional_notes">{ currentRevision.additionalNotes.trim() }</p>
                </div>
            }
        </div>
    );
}

Quote.propTypes = {
    view: PropTypes.string.isRequired,
    quote: PropTypes.object.isRequired
};

function getComparisonRevisions(quoteArray, activeQuoteInfo){
    const previous = quoteArray.find( quoteRev => quoteRev.revisionNumber === activeQuoteInfo.revisionNumber );
    const current = quoteArray.find( quoteRev => ( quoteRev.revisionNumber === (Number(activeQuoteInfo.revisionNumber) + 1).toString() ) );
    return {
        currentRevision: current,
        previousRevision: previous
    };
}

function diffRevisions(prev, current){
    const changes = {
        'estimatedTotalValue': false,
        'expirationDate': false,
        'standardItems': [],
        'miscellaneousItems': [],
        'machinesAndTools': []
    };

    /* check estimated total value and expiration date */
    if ( prev.generalInformation.activationDuration.expirationDate !== current.generalInformation.activationDuration.expirationDate ){
        changes.expirationDate = true;
    }
    if ( prev.generalInformation.generalDetails.estimatedTotalValue !== current.generalInformation.generalDetails.estimatedTotalValue ){
        changes.estimatedTotalValue = true;
    }
    /* check standard items. Two loops for symmetric difference (items removed vs. items added) */
    prev.productInformation.standardItems.forEach( prevItem => {
        let itemObj = current.productInformation.standardItems.find( currentItem => currentItem.productDescription === prevItem.productDescription );
        if ( itemObj ){
            if ( itemObj.discount !== prevItem.discount || itemObj.percentage !== prevItem.percentage ){ //item exists but discount was changed
                changes.standardItems.push( { change: 'old', ...prevItem } );
                changes.standardItems.push( { change: 'new', ...itemObj } );
            } else { //nothing changed
                changes.standardItems.push( { change: 'none', ...prevItem } );
            }
        } else { //item doesn't exist in current version, item was removed
            changes.standardItems.push( { change: 'old', ...prevItem } );
        }
    });

    current.productInformation.standardItems.forEach( currentItem => {
        let itemObj = prev.productInformation.standardItems.find( prevItem => currentItem.productDescription === prevItem.productDescription );
        if ( !itemObj ){ //item was added
            changes.standardItems.push( { change: 'new', ...currentItem } );
        }
    });

    /* check miscellaneous items. Two loops for symmetric difference (items removed vs. items added) */
    prev.productInformation.miscellaneousItems.forEach( prevItem => {
        let itemObj = current.productInformation.miscellaneousItems.find( currentItem => currentItem.productDescription === prevItem.productDescription );
        if ( itemObj ){
            if ( itemObj.totalPercentOff !== prevItem.totalPercentOff || itemObj.netPricing !== prevItem.netPricing ){ //item exists but discount was changed
                changes.miscellaneousItems.push( { change: 'old', ...prevItem } );
                changes.miscellaneousItems.push( { change: 'new', ...itemObj } );
            } else { //nothing changed
                changes.miscellaneousItems.push( { change: 'none', ...prevItem } );
            }
        } else { //item doesn't exist in current version, item was removed
            changes.miscellaneousItems.push( { change: 'old', ...prevItem } );
        }
    });

    current.productInformation.miscellaneousItems.forEach( currentItem => {
        let itemObj = prev.productInformation.miscellaneousItems.find( prevItem => currentItem.productDescription === prevItem.productDescription );
        if ( !itemObj ){ //item was added
            changes.miscellaneousItems.push( { change: 'new', ...currentItem } );
        }
    });

    /* check machine rentals. Two loops for symmetric difference (machines removed vs. machines added) */
    prev.machinesAndTools.forEach( prevMachine => {
        let machineObj = current.machinesAndTools.find( currentMachine => currentMachine.machineDescription === prevMachine.machineDescription );
        if ( machineObj ){
            if ( machineObj.rentalDuration !== prevMachine.rentalDuration ){ //machine exists but rental duration was changed
                changes.machinesAndTools.push( { change: 'old', ...prevMachine } );
                changes.machinesAndTools.push( { change: 'new', ...machineObj } );
            } else { //nothing changed
                changes.machinesAndTools.push( { change: 'none', ...prevMachine } );
            }
        } else { //machine doesn't exist in current version, machine was removed
            changes.machinesAndTools.push( { change: 'old', ...prevMachine } );
        }
    });

    current.machinesAndTools.forEach( currentMachine => {
        let machineObj = prev.machinesAndTools.find( prevMachine => currentMachine.machineDescription === prevMachine.machineDescription );
        if ( !machineObj ){ //machine was added
            changes.machinesAndTools.push( { change: 'new', ...currentMachine } );
        }
    });

    return changes;
}

export default Quote;